__turbopack_context__.v({
  "iframe": "component-module__N_xdTG__iframe",
});
